import { render, staticRenderFns } from "./PromotionRowOfferLabel.vue?vue&type=template&id=c6f5a7ca&scoped=true"
import script from "./PromotionRowOfferLabel.vue?vue&type=script&lang=ts&setup=true"
export * from "./PromotionRowOfferLabel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./PromotionRowOfferLabel.vue?vue&type=style&index=0&id=c6f5a7ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6f5a7ca",
  null
  
)

export default component.exports